import { FieldRendererProps } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import StringFieldRenderer from "@crispico/foundation-react/entity_crud/fieldRenderers/StringFieldRenderer";
import { Icon, Popup } from "semantic-ui-react";
import React from "react";

export class FlightPlaneIdentifierFieldRenderer extends StringFieldRenderer<FieldRendererProps> {

    private renderTooltip(): React.ReactNode {
        const { entity } = this.props;
        if (!entity) {
            return null;
        }
        return <>
            {entity.lastModifiedPlaneIdentifier}
            {entity.modifiedPlaneIdentifier && <Icon name="arrow right" />}
            {entity.planeIdentifier}
        </>
    }

    protected getContent() {
        const { entity } = this.props;
        const content = super.getContent();
        // entity can be null when rendering rotationFlight.planeIdentifier if rotationFlight is null
        if (!entity || !entity.modifiedPlaneIdentifier) {
            return content;
        }
        return <div className="flex-container-row">
            <Popup trigger={<Icon name="plane" color="red" />} className="no-margin-padding">
                {this.renderTooltip()}
            </Popup>
            {content}
        </div>
    }
}
